<template>
  <b-container fluid class="bg-white lz-controls">
    <div class="row">
      <div class="col-lg-10 text-left">
        <ul class="filters-list">
          <li>
            <treeselect
              placeholder="All team members"
              v-model="teamTreeSettings.value"
              :disabled="loading"
              :multiple="teamTreeSettings.multiple"
              :clearable="teamTreeSettings.clearable"
              :searchable="teamTreeSettings.searchable"
              :open-on-click="teamTreeSettings.openOnClick"
              :close-on-select="teamTreeSettings.closeOnSelect"
              :limit="teamTreeSettings.limit"
              :options="teamTreeSettings.options" />
          </li>
          <li>
            <treeselect
              placeholder="All Roles"
              v-model="rolesTreeSettings.value"
              :disabled="loading || teamTreeSettings.value ? true : false"
              :multiple="rolesTreeSettings.multiple"
              :clearable="rolesTreeSettings.clearable"
              :searchable="rolesTreeSettings.searchable"
              :open-on-click="rolesTreeSettings.openOnClick"
              :close-on-select="rolesTreeSettings.closeOnSelect"
              :limit="rolesTreeSettings.limit"
              :options="rolesTreeSettings.options" />
          </li>
          <li v-if="allowImport">
            <div class="d-flex justify-content-center mb-3">
              <b-form-checkbox
                v-if="!showActiveUsersOnly"
                v-model="showActiveUsersOnly"
                :disabled="loading"
                @change="fetchData"
                size="sm"
                class="check-active-users"
                button
                button-variant="secondary">
                Toggle Status (Showing All Users)
              </b-form-checkbox>
              <b-form-checkbox
                v-else
                v-model="showActiveUsersOnly"
                :disabled="loading"
                @change="fetchData"
                size="sm"
                class="check-active-users"
                button
                button-variant="secondary">
                Toggle Status (Showing Active Users Only)
              </b-form-checkbox>
            </div>
          </li>
          <li v-if="showYearFilter">
            <b-form-radio-group
              v-if="!loading && selectedYear"
              size="sm"
              class="allowance-year-group"
              v-model="selectedYear"
              :options="yearLabels"
              button-variant="outline-secondary"
              buttons></b-form-radio-group>
          </li>
        </ul>
      </div>
      <div class="col-lg-2 text-right">
        <b-button
          variant="outline-primary"
          @click="refreshData(true)"
          size="sm"
          >Refresh Data</b-button
        >
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <user-stats-list
          :listItems="listItems"
          :extra-info="allowImport"
          :pager="pager"
          :loading="loading" />
      </div>
    </div>
  </b-container>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import Services from '../../services/main.service.vue'
import UserStatsList from './userstats-components/List.vue'

export default {
  name: 'UserStatsComponenet',
  props: {
    allowImport: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Treeselect,
    UserStatsList
  },
  data() {
    return {
      loading: false,
      showYearFilter: false,
      showActiveUsersOnly: true,
      selectedYear: null,
      yearLabels: [],
      pager: {
        perPage: 50,
        currentPage: 1,
        totalRows: 1,
        totalPages: 1
      },
      listItems: [],
      q: '',
      teamTreeSettings: {
        value: null,
        multiple: false,
        clearable: true,
        searchable: true,
        openOnClick: true,
        closeOnSelect: true,
        limit: 1,
        options: []
      },
      rolesTreeSettings: {
        value: null,
        multiple: false,
        clearable: true,
        searchable: true,
        openOnClick: true,
        closeOnSelect: true,
        limit: 1,
        options: []
      }
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    Sort() {
      return this.Store.userStatsSort.join(',')
    }
  },
  mounted() {
    this.$root.$on('tab_userstats_selected', this.tabMounted)
    this.$root.$on('refresh-userstats-list', this.fetchData)
    // this.$root.$on('setActivitiesSearchQuery', this.searchActivities)
  },
  methods: {
    async tabMounted() {
      this.resetYearLabels()
      await this.fetchData()
    },
    resetYearLabels() {
      const currentYear = new Date().getFullYear()
      const previousYear = currentYear - 1
      this.yearLabels = [
        {
          value: previousYear,
          text: previousYear
        },
        {
          value: currentYear,
          text: currentYear
        }
      ]
      this.selectedYear = currentYear
    },
    async fetchData(page = this.pager.currentPage) {
      try {
        this.loading = true
        const UserStats = await Services.UserStats.Admin.getList({
          owner: this.teamTreeSettings.value,
          role: this.rolesTreeSettings.value,
          activeUsers: this.showActiveUsersOnly,
          page,
          sort: this.Sort
        })
        if (this.teamTreeSettings.value) {
          this.listItems = [UserStats.data.content]
          this.pager.currentPage = 1
          this.pager.totalRows = 1
          this.pager.totalPages = 1
        } else {
          const { info, team, data } = UserStats.data.content
          if (info.total === 0) {
            this.listItems = []
            this.loading = false
            return
          }
          let listLength = info.page * info.perPage
          if (info.total < listLength) {
            listLength = info.total
          }
          this.listItems = new Array(listLength).fill({})
          this.pager.currentPage = info.page
          this.pager.totalRows = info.total
          this.pager.totalPages = Math.ceil(
            this.pager.totalRows / this.pager.perPage
          )
          const firstIndex = (info.page - 1) * info.perPage
          let dataItr = 0
          for (let i = firstIndex; i < listLength; i++) {
            this.listItems[i] = data[dataItr]
            dataItr++
          }
          if (team && team.length) {
            this.teamTreeSettings.options = team.map((member) => {
              return {
                id: member.uid,
                label: member.fullName
              }
            })
          }
        }
        setTimeout(() => {
          if (this.rolesTreeSettings.options.length === 0) {
            this.getRolesList()
          } else {
            this.loading = false
          }
        }, 500)
      } catch (Exception) {
        console.error(Exception)
        this.pager = {
          perPage: 25,
          currentPage: 1,
          totalRows: 1,
          totalPages: 1
        }
        this.listItems = []
        this.loading = false
      }
    },
    async getRolesList() {
      try {
        this.loading = true
        const { status, data } = await Services.Users.Admin.getRolesList()
        if (status === 200) {
          this.rolesTreeSettings.options = data.content.map((role) => {
            return {
              id: role.value,
              label: role.label
            }
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        throw new Error(err.message)
      }
    },
    refreshData(force = false) {
      this.loading = true
      force = !force ? !this.listItems.length : force
      if (force) {
        Services.UserStats.Admin.refreshData()
          .then(() => {
            this.tabMounted()
            this.loading = false
          })
          .catch((err) => {
            console.error(err)
            this.loading = false
          })
      } else {
        this.fetchData()
      }
    },
    loadData() {
      this.loading = true
      this.fetchData()
    },
    searchActivities(q) {
      if (this.loading) {
        return
      }
      this.q = q.trim()
      if (this.q.length === 0 || this.q.length >= 3) {
        this.fetchData()
      }
    }
  },
  watch: {
    'teamTreeSettings.value': {
      handler(val) {
        if (val) {
          this.rolesTreeSettings.value = null
        }
        this.fetchData()
      }
    },
    'rolesTreeSettings.value': {
      handler() {
        this.fetchData()
      }
    },
    selectedYear: {
      handler(val) {
        if (!val) return
        this.fetchData()
      }
    },
    Sort: {
      handler(val) {
        this.fetchData()
      }
    }
  }
}
</script>

<style>
ul.filters-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
ul.filters-list li {
  display: inline-block;
  padding: 0;
  margin: 10px;
  max-width: 300px !important;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  justify-content: center;
  align-items: center;
  vertical-align: top !important;
}
ul.filters-list li .check-active-users label {
  max-height: fit-content !important;
  padding: 2px 10px !important;
  margin: 0 !important;
  line-height: 2 !important;
  vertical-align: middle !important;
  box-sizing: border-box;
  font-size: 75% !important;
}
/* .allowance-year-group is styled centrally in src/styles/logs.css. */
</style>
